import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { PostAddOutlined } from '@mui/icons-material';

import DashboardLayout from 'components/dashboardLayout/dashboardLayout';
import ToastMessage from 'components/toastMessage';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { Button } from 'components/ui';
import { EdiExport } from './EdiExport/EdiExport';
import { JPKFA4Export } from './JPK_FA_4/JPKFA4Export';
import { ComarchXmlExport } from '../Exports/ComarchXmlExport/ComarchXmlExport';

import * as Styled from './Exports.styles';

export const Exports = () => {
  const [toastData, setToastData] = useState(null);

  const onErrorResponse = (error) => {
    setToastData({ severity: 'error', message: error.detail });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {toastData && (
        <ToastMessage
          open
          onClose={() => setToastData(null)}
          severity={toastData.severity}
          message={toastData.message}
        />
      )}
      <Styled.Wrapper>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={4} xxl={3}>
            <Styled.Menu>
              <Button
                variant="text"
                color="secondary"
                className="menuItem"
                onClick={() => document.getElementById('edi-export').scrollIntoView({ behavior: 'smooth' })}
              >
                <PostAddOutlined /> Eksport EDI
              </Button>
              <Button
                  variant="text"
                  color="secondary"
                  className="menuItem"
                  onClick={() => document.getElementById('comarch-xml-export').scrollIntoView({ behavior: 'smooth' })}
                >
                  <PostAddOutlined /> Eksport Comarch ERP Optima
                </Button>  
              <Button
                variant="text"
                color="secondary"
                className="menuItem"
                onClick={() => document.getElementById('jpk-fa-4-export').scrollIntoView({ behavior: 'smooth' })}
              >
                <PostAddOutlined /> Eksport JPK FA
              </Button>            
            </Styled.Menu>
          </Grid>

          <Grid item xs={12} lg={8} xxl={9}>
            <Styled.Content>
              <div id="edi-export">
                <EdiExport onErrorResponse={onErrorResponse}/>
              </div>
              <div id="comarch-xml-export">
                <ComarchXmlExport onErrorResponse={onErrorResponse} />
              </div>
              <div id="jpk-fa-4-export">
                <JPKFA4Export onErrorResponse={onErrorResponse} />
              </div>
            </Styled.Content>
          </Grid>
        </Grid>
      </Styled.Wrapper>
    </DashboardLayout>
  );
};
